export default {"src":"/_next/static/media/1.1-h.372b1ea4.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};